// The KEYCAP — one key of a keyboard shortcut, shown beside the command it
// runs: ⌘ K on the search pill, ⌘ E on a menu row (DESIGN_SPEC §5.9,
// references r004 r072). A `<kbd>`: the `Code` face at `Y` in `caption` ink,
// on the resting `layer` wash, a small rounded square at least `iconMd`
// (20px) on each side so a one-glyph key never collapses into a sliver.
//
//   Shortcut: {
//     flow: 'x', gap: 'W',
//     AppKeycap: { text: '⌘' },
//     AppKeycap_1: { text: 'K' }
//   }
//
// Render a keycap ONLY where the shortcut is wired — a keycap for a key that
// does nothing is a lie. On a menu's highlighted row the caps lift to the
// sheet (`dialog` + `float`); that rule belongs to the row (MenuPanelItem),
// which knows it is highlighted. A shortcut row names its keys to assistive
// technology with `aria-keyshortcuts` on the command itself; the caps stay
// visual. The corner is the house control radius (em-based: ~9px at the
// keycap's own `Y` type) — the design-language lock allows semantic radii
// only.
export const AppKeycap = {
  tag: 'kbd',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  minWidth: 'iconMd',
  height: 'iconMd',
  padding: '0 X',
  round: 'radiusControl',
  theme: 'layer',
  fontFamily: 'Code',
  fontSize: 'Y',
  fontWeight: '500',
  lineHeight: '1',
  color: 'caption',
  whiteSpace: 'nowrap',
  // The hook MenuPanelItem's lift rule keys on — flat, so a call-site `data`
  // object cannot replace it (FW-ELEMENT-DEFINITION-DATA-REPLACES-EXTENDS-DATA-1).
  dataKeycap: true
}
